import { Component } from '@angular/core';

@Component({
  selector: 'era-panel-header',
  templateUrl: './panel-header.component.html',
})
export class PanelHeaderComponent {}
